<template>
    <slot name="filter-field-checkbox" v-bind="this"></slot>
</template>

<script>
export default {
    methods: {
        handleOptionUpdate(updatedFilter) {
            this.$emit('update-option', updatedFilter);
        }
    }
};
</script>
